import * as Types from 'app/types/schema';

import gql from 'graphql-tag';
export type ContainerOrderDetailFragment = { __typename?: 'OrderRequestSchema', id: string, orderRequestCode: string, title?: string | null, createdAt: string, destinationSiteId: string, departmentId?: string | null, deliverToId?: string | null, billToSiteId: string, entityIdInSourceTenant?: string | null, dueDate: string, status: Types.OrderRequestItemStatusEnum, leastItemStatus: Types.OrderRequestItemStatusEnum, type?: Types.OrderRequestTypeEnum | null, childTenantId?: string | null, parentTenantId?: string | null, createdBy: { __typename?: 'UserSchema', id: string, name: string, emailId: string }, destinationSite: { __typename?: 'LocationSchema', id: string, name: string }, deliverTo: { __typename?: 'UserSchema', id: string, name: string }, department?: { __typename?: 'DepartmentSchema', id: string, name: string } | null, billToSite: { __typename?: 'LocationSchema', id: string, name: string }, orderRequestItems: Array<{ __typename?: 'OrderRequestItemSchema', id: string, imageUrl?: string | null, itemId?: string | null, description?: string | null, entityIdInSourceTenant?: string | null, itemIdInPartnerTenant?: string | null, upcCode?: string | null, website?: string | null, status: Types.OrderRequestItemStatusEnum, type: Types.OrderRequestItemTypeEnum, quantity: number, projectId?: string | null, cost?: string | null, note?: string | null, parentOrderRequestItemId?: string | null, project?: { __typename?: 'ProjectSchema', id: string, name: string } | null, nonRemovableNotes?: Array<{ __typename?: 'OrderRequestItemNonRemovableNoteSchema', estimatedDeliveryDate?: string | null, orderId?: string | null, vendor?: string | null }> | null, item?: { __typename?: 'AssetItemSchema', id: string, sku: string, title: string, entityIdInSourceTenant?: string | null, categoryId: string, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, mimeType?: string | null }> | null } | { __typename?: 'AssetKitItemSchema', id: string, sku: string, title: string, entityIdInSourceTenant?: string | null, categoryId: string, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, mimeType?: string | null }> | null } | { __typename?: 'AssetModelItemSchema' } | { __typename?: 'InventoryItemSchema', id: string, sku: string, title: string, entityIdInSourceTenant?: string | null, categoryId: string, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, mimeType?: string | null }> | null } | { __typename?: 'InventoryKitItemSchema', id: string, sku: string, title: string, entityIdInSourceTenant?: string | null, categoryId: string, attachments?: Array<{ __typename?: 'MediaSchema', url?: string | null, mimeType?: string | null }> | null } | null }> };

export const ContainerOrderDetailFragmentDoc = gql`
    fragment ContainerOrderDetail on OrderRequestSchema {
  id
  orderRequestCode
  title
  createdAt
  createdBy {
    id
    name
    emailId
  }
  destinationSiteId
  departmentId
  deliverToId
  billToSiteId
  entityIdInSourceTenant
  destinationSite {
    id
    name
  }
  deliverTo {
    id
    name
  }
  department {
    id
    name
  }
  billToSite {
    id
    name
  }
  createdAt
  dueDate
  status
  leastItemStatus
  type
  childTenantId
  parentTenantId
  orderRequestItems {
    id
    imageUrl
    itemId
    description
    entityIdInSourceTenant
    itemIdInPartnerTenant
    upcCode
    website
    status
    type
    quantity
    projectId
    project {
      id
      name
    }
    cost
    nonRemovableNotes {
      estimatedDeliveryDate
      orderId
      vendor
    }
    note
    parentOrderRequestItemId
    item {
      ... on AssetItemSchema {
        id
        sku
        title
        entityIdInSourceTenant
        categoryId
        attachments {
          url
          mimeType
        }
      }
      ... on AssetKitItemSchema {
        id
        sku
        title
        entityIdInSourceTenant
        categoryId
        attachments {
          url
          mimeType
        }
      }
      ... on InventoryItemSchema {
        id
        sku
        title
        entityIdInSourceTenant
        categoryId
        attachments {
          url
          mimeType
        }
      }
      ... on InventoryKitItemSchema {
        id
        sku
        title
        entityIdInSourceTenant
        categoryId
        attachments {
          url
          mimeType
        }
      }
    }
  }
}
    `;